
import { RouteReuseStrategy, DetachedRouteHandle, ActivatedRouteSnapshot } from "@angular/router";
export class ReuseStrategy implements RouteReuseStrategy {
    private routes = ['import-details'];
    private cache = new Map<string, DetachedRouteHandle | null>();


    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig;
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        let path = this.getPath(route);
        return this.routes.includes(path) && !!this.cache.get(path);
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        let path = this.getPath(route);
        return this.cache.get(path) || null;
    }

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        let path = this.getPath(route);
        return this.routes.includes(path);
    }

    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
        let path = this.getPath(route);

        if(this.routes.includes(path) && handle)
            this.cache.set(path, handle);
    }

    private getPath(route: ActivatedRouteSnapshot) {
        return route.routeConfig ? route.routeConfig.path || '' : '';
    }
}